import React from 'react';
import 'dayjs/locale/en-gb';
import {BoolDictionary} from "../custom_types/customTypes";
import ConfirmDialog from "./ConfirmDialog";
import {AmountInput} from "../form_inputs/AmountInput";
import {InterestInput} from "../form_inputs/InterestInput";
import {PaymentNumberInput} from "../form_inputs/PaymentNumberInput";
import {EffectiveDateInput} from "../form_inputs/EffectiveDateInput";

const AddReducedPaymentOrDMPDialog = (props: { id: string; icon: any; button_type: "list" | "show";
    fields: any, purpose: "REDUCED_PAYMENT" | "DMP", label: "Reduced Payment" | "DMP" }) => {
    const DialogField = (props: { fieldKey: string, onChange: any, error: boolean }) => {
        if (props.fieldKey === "amount") {
            return (<AmountInput {...props} />)
        }
        if (props.fieldKey === "interest") {
            return (<InterestInput {...props} />)
        }
        if (props.fieldKey === "effective_date") {
            return (<EffectiveDateInput {...props} />)
        }
        return (<PaymentNumberInput {...props} />)
    }

    const getParams = (id: any, values: any) => {
        return {
            data: {
                loan: id,
                regular_payment_amount: values['amount'],
                interest_rate: values['interest'],
                effective_date: values['effective_date'],
                purpose: props.purpose,
                contracted: false,
            }
        }
    }

    const getFormFields = (fields: any, getOnChange: any, errors: BoolDictionary) => {
        return fields.map((fieldKey: string) => (
            <DialogField fieldKey={fieldKey} onChange={getOnChange(fieldKey)} error={errors[fieldKey]} key={fieldKey} />
        ));
    }

    return (<ConfirmDialog {...props}
                           getParams={getParams}
                           getFormFields={getFormFields}
                           data_provider_endpoint="vault/loan/mutation/"
                           data_provider_call_type="create"
                           label={props.label}
                           contracted={false}
                           formValidationAlert="Please enter reduced payment amount and effective loan mutation date"
                           requestErrorMessage="An unexpected error occurred when adding reduced payment. Please report this issue to engineering."
                           redirectTo={'/vault/loan/loans/' + props.id + '/show/expected_schedule/'}
        />
    )
}

export default AddReducedPaymentOrDMPDialog